import React, { ReactNode } from 'react'
import { Modal, ModalProps, Typography } from 'antd'
import './index.scss'

const ActionConfirmationModal: React.FC<
  ModalProps & {
    icon?: ReactNode
    title: ReactNode
    onClose: () => void
    description: ReactNode
    isOpen: boolean
    footer: ReactNode[]
    descriptionType?: string
  }
> = (props) => {
  const { isOpen, onClose, title, description, icon, descriptionType = '', ...rest } = props

  return (
    <Modal
      className='action-confirm-modal'
      centered
      onCancel={onClose}
      open={isOpen}
      keyboard={false}
      maskClosable={false}
      {...rest}
    >
      {icon ? <center>{icon}</center> : null}

      <Typography.Text className='title'>{title}</Typography.Text>

      {typeof description === 'string' || descriptionType === 'string' ? (
        <Typography.Text
          className='description'
          type='secondary'
          style={{
            textAlign: 'center',
            fontSize: 16,
          }}
        >
          {description}
        </Typography.Text>
      ) : (
        description
      )}
    </Modal>
  )
}

export default ActionConfirmationModal
